import { Component, inject, OnInit, ViewChild } from '@angular/core';
import { PageHeaderComponent } from '../../../../components/shared/page-header/page-header.component';
import { FormBuilderComponent } from '../../../../components/form-builder/form-builder.component';
import { ButtonModule } from 'primeng/button';
import { TabsModule } from 'primeng/tabs';
import { ContactComponent } from '../../contact/contact.component';
import { BankDetailsComponent } from '../../bank-details/bank-details.component';
import { DynamicForm } from '../../../../components/form-builder/form-builder.types';
import { FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { TableModule } from 'primeng/table';
import { IconFieldModule } from 'primeng/iconfield';
import { InputIconModule } from 'primeng/inputicon';
import { TagModule } from 'primeng/tag';
import { MenuModule } from 'primeng/menu';
import { DialogModule } from 'primeng/dialog';
import { InputTextModule } from 'primeng/inputtext';
import { SelectModule } from 'primeng/select';
import { DrawerModule } from 'primeng/drawer';
import { CompanyService } from '../company.service';
import { RefParamsService } from '../../ref-params/ref-params.service';
import { getCompanyFormObject } from '../utils/company-form-object';
import { CompanyRepository } from '../../../../store/company-state/company-state.repository';
import { MessageService } from 'primeng/api';
import { getFormBuilderObjectFactory } from '../../../../components/form-builder/utils/form-builder-factory';
import { ActivatedRoute, Router } from '@angular/router';
import { AddressComponent } from '../../address/address.component';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { SpinnerComponent } from '../../../../components/shared/spinner/spinner.component';
import { forkJoin } from 'rxjs';
import { RefTypeEnum } from '@/types';
import { TranslateModule, TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'sm-update-company',
  imports: [
    PageHeaderComponent,
    FormBuilderComponent,
    ButtonModule,
    TabsModule,
    ContactComponent,
    AddressComponent,
    BankDetailsComponent,
    PageHeaderComponent,
    CommonModule,
    ButtonModule,
    TableModule,
    IconFieldModule,
    InputIconModule,
    TagModule,
    MenuModule,
    DialogModule,
    InputTextModule,
    FormsModule,
    SelectModule,
    DrawerModule,
    TabsModule,
    ProgressSpinnerModule,
    SpinnerComponent,
    TranslateModule,
  ],
  templateUrl: './update-company.component.html',
  styleUrl: './update-company.component.scss',
})
export class UpdateCompanyComponent implements OnInit {
  //services
  companyService = inject(CompanyService);
  companyRepository = inject(CompanyRepository);
  refParamsService = inject(RefParamsService);
  messageService = inject(MessageService);
  activatedRoute = inject(ActivatedRoute);
  translate = inject(TranslateService);
  router = inject(Router);

  @ViewChild(FormBuilderComponent) formBuilderComponent!: FormBuilderComponent;

  breadcrumb = [
    {
      label: 'settings.companyInfo.breadcrumb.parametres',
      routerLink: ['/settings'],
    },
    {
      label: 'settings.companyInfo.breadcrumb.companyInfo',
      routerLink: ['/settings', 'company'],
    },
    {
      label: 'settings.companyInfo.breadcrumb.update',
      routerLink: ['/settings', 'company', 'update'],
    },
  ];
  selectedTab = '0';

  formObject: DynamicForm = getFormBuilderObjectFactory();
  formDateLoading = false;
  loading = false;

  id = 0;
  companiesTypesOptions: { name: string; code: number }[] = [];
  companyCategoriesOptions: { name: string; code: number }[] = [];

  ngOnInit(): void {
    this.formDateLoading = true;
    this.initRouting();
    this.companyService.getOneCompany(this.id).subscribe({
      next: response => {
        this.companyRepository.set('dto', {
          nom: response.nom,
          typeId: response.type?.id,
          nif: response.nif,
          dateNif: response.dateNif,
          numCnss: response.numCnss,
          categorieSoumissionnaireId: response.categorieSoumissionnaire?.id,
        });
        this.companyRepository.set('companyTypeSelected', {
          name: response.type?.code,
          code: response.type?.id,
        });
        this.companyRepository.set('companyCategorySelected', {
          name: response.categorieSoumissionnaire?.code,
          code: response.categorieSoumissionnaire?.id,
        });

        forkJoin({
          types: this.refParamsService.getSpecializedRefParams(RefTypeEnum.COMPANY_TYPE),
          categories: this.refParamsService.getSpecializedRefParams(RefTypeEnum.ACTIVITY_TYPE),
        }).subscribe(({ types, categories }) => {
          this.companiesTypesOptions = types.map(type => ({ name: type.code, code: type.id }));
          this.companyCategoriesOptions = categories.map(cat => ({ name: cat.code, code: cat.id }));

          this.formObject = getCompanyFormObject({
            store: this.companyRepository,
            companiesTypesOptions: this.companiesTypesOptions,
            companyCategoriesOptions: this.companyCategoriesOptions,
          });
          this.formDateLoading = false;
        });
      },
      error: () => {
        this.messageService.add({
          severity: 'error',
          summary: 'Erreur',
          detail: this.translate.instant('settings.company.message.error.loading'),
        });
      },
    });
  }

  initRouting() {
    this.activatedRoute.fragment.subscribe(fragment => {
      if (fragment !== null && ['0', '1', '2'].includes(fragment)) {
        this.selectedTab = fragment;
      }
    });

    this.formDateLoading = true;
    this.id = Number(this.activatedRoute.snapshot.paramMap.get('id'));
  }

  updateCompany() {
    this.loading = true;
    this.companyService.updateCompany(this.id, this.companyRepository.get('dto')).subscribe({
      next: () => {
        this.loading = false;
        this.messageService.add({
          severity: 'success',
          summary: 'Succès',
          detail: this.translate.instant('settings.company.message.success.added'),
        });
      },
      error: () => {
        this.messageService.add({
          severity: 'error',
          summary: 'Erreur',
          detail: this.translate.instant('settings.company.message.error.added'),
        });
      },
    });
  }

  onTabChange(event: any) {
    this.selectedTab = event;
    this.router.navigate([], {
      fragment: event,
      replaceUrl: true,
    });
  }
}
